import React from 'react';
import { STEP_DEFINITIONS, StepId, WEEKDAYS } from '../onboardingQuestions';
import { DistanceUnit } from '../../../types/enums';
import '../Onboarding.css';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const formatAnswer = (stepId: StepId, value: any): string => {
  if (value === null || value === undefined) return '\u2014';
  if (typeof value === 'string') return value;
  if (typeof value === 'number') {
    if (stepId === 'goal_time' || stepId === 'current_pb' || stepId === 'recent_longest_run_time') {
      const h = Math.floor(value / 3600);
      const m = Math.floor((value % 3600) / 60);
      const s = value % 60;
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }
    if (stepId === 'weekly_training_frequency') return `${value} runs/week`;
    if (stepId === 'training_duration') return `${value} weeks`;
    const day = WEEKDAYS.find((d) => d.value === value);
    if (day) return day.label;
    return String(value);
  }
  if (Array.isArray(value)) {
    return value.map((v) => WEEKDAYS.find((d) => d.value === v)?.label || v).join(', ');
  }
  if (typeof value === 'object') {
    if (value.distance !== undefined && value.unit !== undefined) {
      return `${value.distance} ${value.unit === DistanceUnit.KM ? 'km' : 'miles'}`;
    }
    if (value.title) return value.title;
    if (value.name) return value.name;
    return JSON.stringify(value);
  }
  return String(value);
};

const DISPLAY_ORDER: StepId[] = [
  'initial_onboarding', 'date_of_birth', 'gender', 'experience_level',
  'training_purpose', 'programme_type', 'training_distance',
  'race_selection', 'race_date', 'training_duration', 'training_start_date',
  'goal_time', 'current_pb', 'recent_running_history', 'recent_longest_run_time',
  'weekly_training_frequency', 'training_availability', 'long_run_day_preference',
  'training_intensity_preference', 'intensive_workout_days_preference',
  'distance_unit_preference', 'running_community_participation',
  'run_club_day', 'run_club_intensity', 'run_club_distance',
  'additional_information',
];

const SummaryStep: React.FC<StepProps> = ({ answers }) => {
  const answeredSteps = DISPLAY_ORDER.filter((id) => answers[id] !== undefined && answers[id] !== null);

  return (
    <div className="onboarding-scrollable" style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: '55vh' }}>
      {answeredSteps.map((stepId) => {
        const def = STEP_DEFINITIONS[stepId];
        return (
          <div
            key={stepId}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              padding: 16,
              background: 'rgba(250,253,251,0.08)',
              borderRadius: 12,
              border: '1px solid rgba(250,253,251,0.12)',
              gap: 12,
            }}
          >
            <div style={{ flex: 1 }}>
              <div style={{
                fontFamily: "'Figtree', sans-serif",
                fontSize: 14,
                color: 'rgba(250,253,251,0.6)',
                marginBottom: 4,
              }}>
                {def.title}
              </div>
              <div style={{
                fontFamily: "'Figtree', sans-serif",
                fontSize: 16,
                color: '#FAFDFB',
                wordBreak: 'break-word',
              }}>
                {formatAnswer(stepId, answers[stepId])}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SummaryStep;
